"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../data/store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isKeyboardShortcutsOptionDirty(state) {
    var userOptions = state.userOptions, optionState = state.optionState;
    return (owa_options_core_1.getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode) !==
        userOptions.KeyboardShortcutsMode);
});
//# sourceMappingURL=isKeyboardShortcutsOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/utils/isKeyboardShortcutsOptionDirty.js
// module id = 4973
// module chunks = 2